import { createFileRoute } from '@tanstack/react-router';
import { useIsMobileShell } from '@/shared/mobile/useIsMobileShell';
import { MobileBookings } from '@/features/bookings/mobile/MobileBookings';
import { DesktopBookings } from '@/features/bookings/desktop/DesktopBookings';

export const Route = createFileRoute('/_app/instruments-calendar/')({ component: BookingsPage });

/** Selettore: hub Prenotazioni mobile vs calendario prenotazioni desktop. */
function BookingsPage() {
  const isMobile = useIsMobileShell();
  return isMobile ? <MobileBookings /> : <DesktopBookings />;
}
